<template>
    <v-card>
        <v-toolbar color="primary">
            <div
                class="
                    title
                    ml-3
                    mr-5
                    mt-2
                    hidden-sm-and-down
                    align-center
                    d-flex
                "
            >
                <span>
                    <img :src="$config('app.appLogoIcon')" />
                </span>
                <span class="ml-2">
                    <img
                        :src="$config('app.appLogoText')"
                        class="mt-1"
                        height="35"
                    />
                </span>
            </div>
        </v-toolbar>
        <applicant-profile-header
            :assigned-to="assignedTo"
            :applicant="applicant"
        ></applicant-profile-header>
        <v-divider></v-divider>
        <v-card-text class="pb-0">
            <v-row justify="space-between">
                <v-col>
                    <applicant-profile-details
                        :applicant="applicant"
                        :created_at="created_at"
                        :property="property"
                    ></applicant-profile-details>
                </v-col>
                <v-col>
                    <applicant-profile-application
                        :products="products"
                        :applicant="applicant"
                    ></applicant-profile-application>
                </v-col>
                <v-col>
                    <applicant-profile-program
                        :applicant="applicant"
                        v-if="isStudent"
                    >
                    </applicant-profile-program>
                    <applicant-profile-applicants
                        v-if="
                            $_.get(applicant, 'application.applicants', [])
                                .length > 1 && !isStudent
                        "
                        :applicant="applicant"
                    ></applicant-profile-applicants>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
import HasStudent from "@/components/screen/mixins/HasStudent";
export default {
    name: "applicant-profile",
    mixins: [HasStudent],
    components: {
        ApplicantProfileHeader: () => import("./ApplicantProfileHeader"),
        ApplicantProfileDetails: () => import("./ApplicantProfileDetails"),
        ApplicantProfileProgram: () => import("./ApplicantProfileProgram"),
        ApplicantProfileApplication: () =>
            import("./ApplicantProfileApplication"),
        ApplicantProfileApplicants: () =>
            import("./ApplicantProfileApplicants"),
    },
    props: {
        created_at: {
            type: String,
            required: true,
        },
        property: {
            type: Object,
            required: true,
        },
        products: {
            type: Array,
            required: true,
        },
        assignedTo: {
            validator: (prop) => typeof prop === "object",
        },
    },
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    updated() {},
    detroyed() {},
    methods: {},
};
</script>

<style scoped>
</style>